import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeeService } from 'src/app/services/employee.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AccessLevels } from 'src/app/models/access_levels';
import { StationService } from 'src/app/services/station.service';
import { AgentScheduleService } from 'src/app/services/agent-schedule.service';
import { AgentSlotsCalenderComponent } from '../agent-slots-calender/agent-slots-calender.component';
import { BsModalService } from 'ngx-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-employees-new',
  templateUrl: './employees-new.component.html',
  styleUrls: ['./employees-new.component.scss']
})
export class EmployeesNewComponent implements OnInit {


  allEmployees;
  stationsList;
  activePage
  searchText;
  constructor(private router: Router,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService,
    private notifier: NotifierService,
    private employeeService: EmployeeService,
    private authService: AuthenticationService,
    private stationService: StationService,
    private agentScheduleService: AgentScheduleService) {
    this.getData()

  }

  getData() {
    this.searchText = ''
    this.spinner.show();
    if (this.authService.getAccessLevel() == AccessLevels.superAdmin) {
      this.getAllStations();
      this.getEmployees();
    } else {
      this.employeeService.getEmployeeById(this.authService.getCurrentUserId()).subscribe(res => {
        this.stationsList = res['result']['stations']
        this.getEmployeesByStationIds();
      });
    }
  }

  ngOnInit() { 
    this.getData()
  }

  addEmployee() {
    this.router.navigateByUrl("home/add-employee")
  }

  editEmployee(employee) {
    // this.router.navigateByUrl("home/employees/edit-employee")
    this.router.navigate(["home/edit-employee", employee.id])

    // if (this.authService.getAccessLevel() == AccessLevels.superAdmin) {
    //   this.router.navigate(["home/employees/edit-employee", employee.id])
    // } else {
    //   this.router.navigate(["home/employees/edit-employee", employee.id])
    // }
  }

  // excelData: any;
  // wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  // fileName: string = 'SheetJS.xlsx';
  // onFileChange(evt: any) {
  //   try {
  //     /* wire up file reader */
  //     const target: DataTransfer = <DataTransfer>(evt.target);
  //     if (target.files.length !== 1) throw new Error('Cannot use multiple files');
  //     const reader: FileReader = new FileReader();
  //     reader.onload = (e: any) => {
  //       this.isExcleUploaded = true

  //       /* read workbook */
  //       const bstr: string = e.target.result;
  //       const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

  //       /* grab first sheet */
  //       const wsname: string = wb.SheetNames[0];
  //       const ws: XLSX.WorkSheet = wb.Sheets[wsname];

  //       /* save data */
  //       this.excelData = (XLSX.utils.sheet_to_json(ws, { header: 1 }));
  //     };
  //     reader.readAsBinaryString(target.files[0]);
  //   } catch (e) {
  //   }
  // }

  uploadEmployees() { }

  getEmployees() {
    if (this.authService.getAccessLevel() == AccessLevels.superAdmin) {
      this.employeeService.getAllEmployees().subscribe(employees => {
        this.spinner.hide();
        this.allEmployees = employees['result'] as [];
      });
    }
  }

  getEmployeesByStationIds() {
    this.employeeService.getEmployeesByStationId(this.stationsList).subscribe(data => {
      this.spinner.hide();
      if (data['result'] != null) {
        this.allEmployees = data['result'] as [];
        this.allEmployees = this.allEmployees.reverse();
      }
    });
  }

  calculateActiveEmployees(employees) {
    let activeCount = 0
    employees.forEach(emp => {
      if (emp.active) {
        activeCount++
      }
    });
    return activeCount
  }

  calculateInActiveEmployees(employees) {
    let inactiveCount = 0
    employees.forEach(emp => {
      if (!emp.active) {
        inactiveCount++
      }
    });
    return inactiveCount
  }

  getAllStations() {
    this.stationService.getStations().subscribe(stations => {
      this.stationsList = stations['result'];
    })
  }


  getAvailableSlots(employee) {
    this.spinner.show()
    this.agentScheduleService.getSchedulesByUserId(employee.id).subscribe(availableSlots => {
      this.spinner.hide()
      if (availableSlots['status']) {
        if (availableSlots['result'].length != 0) {
          let slots = availableSlots['result'] as []
          const initialState = {
            dialogData: { "employeeName": employee.firstname + ' ' + employee.lastname, "slots": slots.reverse() },
          };
          const modalRef = this.modalService.show(AgentSlotsCalenderComponent, { initialState });
          modalRef.setClass('modal-lg');
        } else {
          this.notifier.notify('warning', 'No schedules found!')
        }
      }
    })
  }
}